/*
    © 2021 NetSuite Inc.
    User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
    provided, however, if you are an authorized user with a NetSuite account or log-in, you
    may use this code subject to the terms that govern your access and use.
*/
define('NSeComm.MultiAddToCart.Main', [
    'MultiAddToCart.Scroll.Helper',
    'MultiAddToCart.Header.View',
    'MultiAddToCart.Button.View',
    'Facets.MultiAddToCart.Cell.View',
    'Facets.MultiAddToCart.Quantity.View',
    'Facets.MultiAddToCart.Options.View',
    'facets_item_cell_multi_add_to_cart.tpl'
], function (
    ScrollHelper,
    MultiAddToCartHeaderView,
    MultiAddToCartButtonView,
    FacetsMultiAddToCartCellView,
    FacetsMultiAddToCartQuantityView,
    FacetsMultiAddToCartOptionsView
) {
    'use strict';

    var isIntersectionObserverSupported = function isIntersectionObserverSupported() {
        return 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window &&
            'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    };

    return {
        getSortingScore: function getSortingScore(val) {
            if (val == '-') {
                return -10;
            } else if (val == '(Not Pictured)') {
                return -9;
            } else if (val == 'Full\nAssembly') {
                return -8;
            } else if (!parseInt(val)) {
                return -1;
            }
            return parseInt(val);
        },
		swapElements: function swapElements($elem1, $elem2) {
			var $temp = $('<div>').insertAfter($elem1);

			$elem1.insertAfter($elem2);
			$elem2.insertBefore($temp);

			$temp.remove();
		},      
        getVisibleText: function getVisibleText(element) {
            return element.get(0).innerText.trim();
            // var $clone = element.clone();
            // return $clone.find('[style*="display:inline"], [style*="display: inline"]').text().trim();
        },
        mountToApp: function mountToApp(container) {
            var plp = container.getComponent('PLP');
            var pdp = container.getComponent('PDP');
            var layout = container.getComponent('Layout');
            var userProfile = container.getComponent('UserProfile');
            var configuration = container.getComponent('Environment');
            var dis = this;

            var multiAddHeaderView;
            var addToCartButtonViews;

            var getRegistrationType = function() {
                return configuration.getSiteSetting('registration.registrationoptional') === 'T' ? 'disabled' : configuration.getSiteSetting('registration.registrationmandatory') === 'T' ? 'optional' : configuration.getSiteSetting('registration.registrationallowed') === 'T' ? 'required' : 'existing'
            }
            var registrationType = getRegistrationType();

            plp.on('beforeShowContent', function () {
                plp.viewToBeRendered.on('afterCompositeViewRender', function (view) {
                    var scrollHelper;

                    if (isIntersectionObserverSupported() && plp.getDisplay().id === 'multi-add-to-cart') {
                        if (!SC.isPageGenerator()) {
                            scrollHelper = ScrollHelper.setUpScroll(view);

                            if (view.$el.find('.facets-items-collection-view-row').length) {
                                view.$el.find('.facets-items-collection-view-row').addClass('facets-items-multi-add-collection-view-row');
                            }

                            if(scrollHelper.start || scrollHelper.end) {
                                scrollHelper.observer.observe(scrollHelper.start);
                                scrollHelper.observer.observe(scrollHelper.end);
                            }
                        }
                    }
                });
            });

            plp.on('afterShowContent', function () {
                setTimeout(function() {
                    var url = window.location.href;
                    var match = url.match(/[?&]display=([^&]*)/);
                    var param = match ? decodeURIComponent(match[1]) : null;
                    if (param == 'multi-add-to-cart') {
                        var match1 = url.match(/[?&]order=([^&]*)/);
                        var param1 = match1 ? decodeURIComponent(match1[1]) : '';
                        if (param1 == '') {
                            var newUrl = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'order=relevance:desc';
                            if (typeof history !== 'undefined' && history.replaceState) {
                                setTimeout(function() {
                                    var len = $("div.facets-items-collection-view-row.facets-items-multi-add-collection-view-row").length;

                                    for (var i = 0; i < len - 1; i++) {
                                        for (var j = 0; j < len - i - 1; j++) {
                                            var products = $("div.facets-items-collection-view-row.facets-items-multi-add-collection-view-row");
                                            var ind_prev = dis.getSortingScore(dis.getVisibleText(products.eq(j).find('h2.facets-item-cell-multi-add-title').eq(0)));
                                            var ind_next = dis.getSortingScore(dis.getVisibleText(products.eq(j + 1).find('h2.facets-item-cell-multi-add-title').eq(0)));
                                            if (ind_prev > ind_next) {
                                                // console.log('multi-swap', j);
                                                dis.swapElements(products.eq(j), products.eq(j + 1));
                                            }
                                        }
                                    }

                                    history.replaceState({}, document.title, newUrl);
                                }, 250);
                            } else {
                                window.location.href = newUrl;
                            }
                        }
                    }
                }, 200);
                return;
            });                                        

            if (plp) {

                plp.addChildView('Facets.MultiAddToCart.Cell', function () {
                    return new FacetsMultiAddToCartCellView({
                        container: container,
                        getRegistrationType: getRegistrationType(),
                        addToCartViews: [addToCartButtonViews]
                    });
                });

                plp.cancelableOn('beforeShowContent', function () {
                    var webcategorylists = configuration.getConfig('webcategorylists') || [];
                    var categoryinfo = plp.getCategoryInfo();
                    if (typeof(categoryinfo) != "undefined") {
                        SC.categoryinfo = categoryinfo;
                    } else {
                        SC.categoryinfo = [];
                    }
                    
                    var plpDisp = plp.getDisplay();
                    var hasCat = _.find(webcategorylists, function(vals){
                        return categoryinfo && plpDisp && vals.custcategoryname.toLowerCase() == categoryinfo.name.toLowerCase();
                    });

                    if(hasCat && plpDisp.id != 'multi-add-to-cart') {
                        // Ensure URL has order=relevance:desc so product list loads sorted; update URL then set display
                        var url = window.location.href;
                        var orderMatch = url.match(/[?&]order=([^&]*)/);
                        var currentOrder = orderMatch ? decodeURIComponent(orderMatch[1]) : '';
                        if (currentOrder !== 'relevance:desc') {
                            var newUrl = orderMatch
                                ? url.replace(/([?&]order=)([^&]*)/, '$1relevance%3Adesc')
                                : url + (url.indexOf('?') >= 0 ? '&' : '?') + 'order=relevance:desc';
                            if (typeof history !== 'undefined' && history.replaceState) {
                                history.replaceState({}, document.title, newUrl);
                            }
                        }
                        plp.setDisplay({display: 'multi-add-to-cart'});
                    }
                });

                plp.cancelableOn('afterShowContent', function () {
                    var webcategorylists = configuration.getConfig('webcategorylists') || [];
                    var categoryinfo = plp.getCategoryInfo();
                    if (typeof(categoryinfo) != "undefined") {
                        SC.categoryinfo = categoryinfo;
                    } else {
                        SC.categoryinfo = [];
                    }

                    // console.log('afterShowContent 444-222-5555');
                    // setTimeout(function() {
                    //     var len = $("div.facets-items-collection-view-row.facets-items-multi-add-collection-view-row").length;

                    //     for (var i = 0; i < len - 1; i++) {
                    //         for (var j = 0; j < len - i - 1; j++) {
                    //             var products = $("div.facets-items-collection-view-row.facets-items-multi-add-collection-view-row");
                    //             console.log('org', dis.getVisibleText(products.eq(j).find('h2.facets-item-cell-multi-add-title').eq(0)), dis.getVisibleText(products.eq(j+1).find('h2.facets-item-cell-multi-add-title').eq(0)))
                    //             var ind_prev = dis.getSortingScore(dis.getVisibleText(products.eq(j).find('h2.facets-item-cell-multi-add-title').eq(0)));
                    //             var ind_next = dis.getSortingScore(dis.getVisibleText(products.eq(j + 1).find('h2.facets-item-cell-multi-add-title').eq(0)));					
                    //             console.log(ind_prev, ind_next);
                    //             if (ind_prev > ind_next) {
                    //                 dis.swapElements(products.eq(j), products.eq(j + 1));
                    //             }
                    //         }
                    //     }
                    // }, 100);

                    // ─── Cross-link row injection (runs after bubble sort completes) ───
                    setTimeout(function() {
                        var catinfo = SC.categoryinfo;
                        var descHtml = catinfo && catinfo.description;
                        if (!descHtml) return;

                        var tempDiv = document.createElement('div');
                        tempDiv.innerHTML = descHtml;
                        var clDiv = tempDiv.querySelector('#ma2c_crosslinks');
                        if (!clDiv) return;

                        var spans = clDiv.querySelectorAll('.crosslink');
                        for (var ci = 0; ci < spans.length; ci++) {
                            var span = spans[ci];
                            var afterItemId = span.getAttribute('data-after-item');
                            var partIndex = span.getAttribute('data-part-index') || '';
                            var clUrl = span.getAttribute('data-url') || '';
                            var thumbnail = span.getAttribute('data-thumbnail') || '';
                            var partDesc = span.textContent || '';

                            var thumbHtml = thumbnail
                                ? '<img class="facets-item-cell-grid-image" src="' + thumbnail + '" alt="' + partDesc.replace(/"/g, '&quot;') + '" />'
                                : '<span style="font-size:24px;">&#8594;</span>';

                            var clRowHtml = '<div class="facets-items-collection-view-row facets-items-multi-add-collection-view-row ma2c-crosslink-row">' +
                                '<div class="facets-item-cell-multi-add-container" data-crosslink="true">' +
                                '<div class="multi-add-quick-add-to-cart-cell-itemnum">' +
                                '<h2 class="facets-item-cell-multi-add-title">' + partIndex + '</h2></div>' +
                                '<a class="facets-item-cell-grid-link-image" href="' + clUrl + '">' + thumbHtml + '</a>' +
                                '<div class="multi-add-quick-add-to-cart-cell-details">' +
                                '<div class="facets-item-cell-multi-add-details">' +
                                '<h2 class="facets-item-cell-multi-add-desctiption">' +
                                '<a class="facets-item-cell-grid-link-desc" href="' + clUrl + '">' + partDesc + '</a>' +
                                '</h2></div></div>' +
                                '<div class="multi-add-quick-add-to-cart-cell-quantity">' +
                                '<a class="ma2c-crosslink-view-details" href="' + clUrl + '">View full details</a>' +
                                '</div>' +
                                '</div></div>';

                            // Empty afterItemId = insert at top of list
                            if (!afterItemId) {
                                var firstRow = jQuery('.facets-items-collection-view-row.facets-items-multi-add-collection-view-row').first();
                                if (firstRow.length) {
                                    jQuery(clRowHtml).insertBefore(firstRow);
                                }
                                continue;
                            }

                            var itemCell = jQuery('.facets-item-cell-multi-add-container[data-item-id="' + afterItemId + '"]');
                            var row = itemCell.closest('.facets-items-collection-view-row');
                            if (!row.length) continue;
                            jQuery(clRowHtml).insertAfter(row);
                        }
                    }, 500);

                    var plpDisp = plp.getDisplay();
                    var hasCat = _.find(webcategorylists, function(vals){
                        return categoryinfo && plpDisp && vals.custcategoryname.toLowerCase() == categoryinfo.name.toLowerCase();
                    });

                    if((hasCat && plpDisp.id == 'multi-add-to-cart') || (!categoryinfo && plpDisp.id == 'multi-add-to-cart')) {
                        jQuery('.facets-item-list-display-selector').remove();
                        jQuery('.facets-facet-browse-list-header-filter-column').remove();
                    }
                    else {
                        jQuery('.facets-item-list-display-selector[title="Multi"]').remove();
                    }

                    _.defer(function(){
                        var containerDiv = jQuery('.facets-items-multi-add-collection-view-row-header');
                        containerDiv.parent().addClass('facets-items-multi-add-collection-view-row-header-floater');
                        //hide badges
                        jQuery('.facets-item-cell-multi-add-container .itembadges-container').hide();
                    });

                    //show part number and description
                    jQuery('.part-number-category-' + categoryinfo.internalid).show();
                    jQuery('.part-desc-number-category-' + categoryinfo.internalid).show();

                    jQuery('.facets-browse-category-heading-main-image').css("text-align", "center");
                    jQuery('.facets-browse-category-heading-main-image img').css({"max-height": "1200", "width": "auto"});
                });

                multiAddHeaderView = new MultiAddToCartHeaderView({ 
                    container: container,
                    getRegistrationType: getRegistrationType()
                });

                addToCartButtonViews = new MultiAddToCartButtonView({ 
                    container: container,
                    getRegistrationType: getRegistrationType()
                });

                plp.addChildViews(plp.PLP_VIEW, { 'Facets.Items': {
                        'AddToCartButton': {
                            childViewIndex: 12,
                            childViewConstructor: function () {
                                return addToCartButtonViews;
                            }
                        },
                        'EndFix': {
                            childViewIndex: 11,
                            childViewConstructor: function () {
                                return new ScrollHelper.floatingListeners({
                                    controllerAttr: 'end-floating'
                                })
                            }
                        }
                    }
                });

                /*
                plp.addChildView('Facets.MultiAddToCart.Quantity', function () {
                    return new FacetsMultiAddToCartQuantityView({
                        container: container,
                        getRegistrationType: getRegistrationType(),
                        addToCartViews: [addToCartButtonViews]
                    });
                });

                plp.addChildView('Facets.MultiAddToCart.Options', function () {
                    return new FacetsMultiAddToCartOptionsView({
                        container: container,
                        getRegistrationType: getRegistrationType()
                    });
                });

                
                plp.addChildView('MultiAddToCart.SingleRow', function () {
                    return new FacetsMultiAddToCartOptionsView({
                        container: container,
                        getRegistrationType: getRegistrationType()
                    });
                });

                plp.addChildView('MultiAddToCart.MulltipleRow', function () {
                    return new FacetsMultiAddToCartOptionsView({
                        container: container,
                        getRegistrationType: getRegistrationType()
                    });
                });
                */

          

            }
            
            if (layout) {
                dis.customAddContextPLP(layout, 'Facets.ItemCell.View', 'custitem_sc_part_index', 'string', plp, userProfile, registrationType, configuration);
                dis.customAddContextPLP(layout, 'Facets.ItemCell.View', 'custitem_sc_part_desc', 'string', plp, userProfile, registrationType, configuration);
                // dis.customAddContextPLP(layout, 'Facets.ItemCell.View', 'itemId', 'string', plp);
                // dis.customAddContextPLP(layout, 'Facets.ItemCell.View', 'url', 'string', plp);
                // dis.customAddContextPLP(layout, 'Facets.ItemCell.View', 'sku', 'string', plp);
                dis.customAddContextPLP(layout, 'Facets.ItemCell.View', 'isMatrixItem', 'boolean', plp, userProfile, registrationType, configuration);
                dis.customAddContextPLP(layout, 'Facets.ItemCell.View', 'childItems', 'object', plp, userProfile, registrationType, configuration);

                layout.addToViewContextDefinition('ProductViews.Price.View', 'isPriceRange', 'boolean', function addNewContext (context) {
                    var categoryInfo = plp.getCategoryInfo();
                    var categoryName = categoryInfo && categoryInfo.name;
                    var originalItem = context.model && context.model.item;

                    if(categoryInfo && categoryName && originalItem) {
                        /*
                        var item = _.find(plp.getItemsInfo(), function (plpItem) {
                            return plpItem.internalid == originalItem.internalid;
                        });
                        */
                        var childItem = _.findWhere(originalItem.matrixchilditems_detail, {custitem_ma2c_category: categoryName});
                        if(childItem) {
                            return false;
                        }
                    }
                    return context.isPriceRange;
                });

                layout.addToViewContextDefinition('ProductViews.Price.View', 'priceFormatted', 'string', function addNewContext (context) {
                    var categoryInfo = plp.getCategoryInfo();
                    var categoryName = categoryInfo && categoryInfo.name;
                    var originalItem = context.model && context.model.item;

                    if(categoryInfo && categoryName && originalItem) {
                        /*
                        var item = _.find(plp.getItemsInfo(), function (plpItem) {
                            return plpItem.internalid == originalItem.internalid;
                        });
                        */
                        var childItem = _.findWhere(originalItem.matrixchilditems_detail, {custitem_ma2c_category: categoryName});
                        if(childItem) {
                            return childItem.onlinecustomerprice_detail && childItem.onlinecustomerprice_detail.onlinecustomerprice_formatted;
                        }
                    }
                    return context.priceFormatted;
                });
            }
        }

    ,   customAddContextPLP: function customAddContextPLP(nEvent, nView, nName, nType, plp, userProfile, registrationType, configuration) {
            //userProfile.getUserProfile().done(function (profile) {
                nEvent.addToViewContextDefinition(nView, nName, nType, function addNewContext (context) {
                var categoryInfo = plp.getCategoryInfo();
                var categoryName = categoryInfo && categoryInfo.name;
                var model = _.find(plp.getItemsInfo(), function (item)
                {
                    return item.internalid == context.itemId
                });
                var isMatrixItem = !!(model && model.matrixchilditems_detail);
                var childItem;
                if(nName === 'custitem_sc_part_desc') {
                    if(isMatrixItem) {
                        childItem = _.findWhere(model.matrixchilditems_detail, {custitem_ma2c_category: categoryName});
                        if(childItem && childItem.custitem_sc_part_desc) {
                            return  childItem.custitem_sc_part_desc;
                        }
                    } else {
                        if(!model[nName]) {
                            return model.storedisplayname;
                        }
                    }
                }

                if(nName === 'custitem_sc_part_index') {
                    if(isMatrixItem) {
                        childItem = _.findWhere(model.matrixchilditems_detail, {custitem_ma2c_category: categoryName});
                        if(childItem && childItem.custitem_sc_part_index) {
                            return  childItem.custitem_sc_part_index;
                        }
                    }
                }

                if(nName === 'isMatrixItem') {
                    return isMatrixItem;
                }

                if(nName === 'childItems') {
                    if(!isMatrixItem) {
                        return [];
                    }
                    var childItems = model.matrixchilditems_detail;
                    var childItem = _.findWhere(model.matrixchilditems_detail, {custitem_ma2c_category: categoryName});
                    var isEnvironmentBrowser = context.isEnvironmentBrowser;
                    var thumbnail = context.thumbnail;
                    var itemIsNavigable = context.itemIsNavigable;
                    var showRating = context.showRating;
                    var rating = context.rating;
                    var isLoggedIn = userProfile.isloggedin;
                                  
                    return _.chain(childItems)
                        .filter(function (matrixChildItem){
                            return matrixChildItem.custitem_ma2c_category && matrixChildItem.custitem_ma2c_category.indexOf(categoryName) !== -1;
                        })
                        .map(function (matrixChildItem){
                            var custitemSCPartDesc = matrixChildItem && matrixChildItem.custitem_sc_part_desc || model.custitem_sc_part_desc;
                            var custitemSCPartIndex = matrixChildItem && matrixChildItem.custitem_sc_part_index || model.custitem_sc_part_index;
                            var custitemRank = matrixChildItem && matrixChildItem.custitem_rank || model.custitem_rank;
                            var itemURL = model.urlcomponent + '?';
                            _.each(model.itemoptions_detail && model.itemoptions_detail.fields, function (field){
                                var optionValue = _.findWhere(field && field.values, {label: matrixChildItem[field.sourcefrom]});
                                if(optionValue) {
                                    itemURL +=  field.internalid + '=' + optionValue.internalid + '&';
                                }
                            });
                            
                            if(itemURL.endsWith('&')) {
                                itemURL = itemURL.slice(0, -1);
                            }

                            var lineItem = SC.SESSION && SC.SESSION.multiAddToCart && SC.SESSION.multiAddToCart[''+ matrixChildItem.internalid];

                            return {
                                // @property {String} itemId
                                itemId: matrixChildItem.internalid || model.internalid, // this.model.get('_id'),
                                // @property {String} name
                                name: matrixChildItem.name || model.name, // this.model.get('_name'),
                                // @property {String} url
                                url: '/' + itemURL, 
                                // @property {String} sku
                                sku: matrixChildItem.itemid || model.itemid, // this.model.getSku(),
                                // @property {Boolean} isEnvironmentBrowser
                                isEnvironmentBrowser: isEnvironmentBrowser,
                                // @property {ImageContainer} thumbnail
                                thumbnail: thumbnail,
                                // @property {Boolean} itemIsNavigable
                                itemIsNavigable: itemIsNavigable,
                                // @property {Boolean} showRating
                                showRating: showRating,
                                // @property {Number} rating
                                rating: rating,
                                // @property {String} track_productlist_list
                                track_productlist_list: context.track_productlist_list,
                                // @property {String} track_productlist_position
                                track_productlist_position: context.track_productlist_position,
                                // @property {String} track_productlist_category
                                track_productlist_category: context.track_productlist_category,
                                custitem_sc_part_desc: custitemSCPartDesc,
                                custitem_sc_part_index: custitemSCPartIndex,
                                custitem_rank: custitemRank,
                                // isLoggedIn: false,//profile.isloggedin,
                                priceFormatted: matrixChildItem.onlinecustomerprice_detail && matrixChildItem.onlinecustomerprice_detail.onlinecustomerprice_formatted,
                                isNotPurchasable: !matrixChildItem.ispurchasable,
                                // ispricevisible
                                //isQuantityEnabled:  !(registrationType !== 'disabled' && configuration.getSiteSetting('requireloginforpricing') === 'T' & profile.isloggedin !== true),
                                qty: lineItem ? lineItem.quantity : 0,
                                 //isNotPurchasable: isNotPurchaseable
                            }
                        })
                        .value();
                }
                
                if(nName === 'url') {
                    return model.urlcomponent;
                }
                return model && model[nName];
            });
            // });
            
        }

    // ,   customAddPriceContextPLP: function customAddPriceContextPLP(nEvent, nView, nName, nType, plp) {
    //         nEvent.addToViewContextDefinition(nView, nName, nType, function addNewContext (context) {
    //             var model = _.find(plp.getItemsInfo(), function (item)
    //             {
    //                 return item.internalid == context.itemId
    //             });

    //             var custPrices = [];
    //             var prices = model[nName];
    //             if(prices && prices.priceschedule && prices.priceschedule.length) {
    //                 var lastObj = {};
    //                 for(var x=0; x<5; x++) {
    //                     if (prices.priceschedule.length >= (x+1)){
    //                        lastObj =  prices.priceschedule[x];
    //                        custPrices.push(lastObj);
    //                     }
    //                     else {
    //                         custPrices.push({minimumquantity: lastObj.minimumquantity, price: lastObj.price, price_formatted: lastObj.price_formatted});
    //                     }
    //                 }
    //             }
    //             else {
    //                 for(var x=0; x<5; x++) {
    //                     custPrices.push({minimumquantity: 0, price: 'N/A', price_formatted: 'N/A'});
    //                 }
    //             }

    //             return custPrices;
    //         });
    //     }
    };

});

